module.exports = __webpack_public_path__ + "350x200_Pinstar_Thmnl.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/350x200_Pinstar_Thmnl.jpg
// module id = 1419
// module chunks = 0